import { render } from "./CourseRelationList.vue?vue&type=template&id=352f96d2"
import script from "./CourseRelationList.vue?vue&type=script&lang=ts"
export * from "./CourseRelationList.vue?vue&type=script&lang=ts"
script.render = render

export default script